import { Fingerprint, Shield, LockKeyhole, BellRing } from "lucide-react";

const pillars = [
  {
    icon: Shield,
    title: "Operational Controls",
    text: "Our operational workflows are built to keep transactions accurate and reduce processing risk.",
  },
  {
    icon: LockKeyhole,
    title: "Account Protection",
    text: "Authentication and request security controls help protect user accounts from unauthorized access.",
  },
  {
    icon: Fingerprint,
    title: "Identity & Compliance",
    text: "Identity verification supports safer transactions and helps us meet compliance requirements.",
  },
  {
    icon: BellRing,
    title: "Incident Visibility",
    text: "Monitoring and notifications help us respond quickly to service issues and keep users informed.",
  },
];

export default function SecurityPage() {
  return (
    <section className="bg-gradient-to-b from-slate-950 via-slate-900 to-slate-800 py-16 text-white md:py-24">
      <div className="mx-auto max-w-6xl px-6">
        <div className="max-w-3xl">
          <p className="mb-3 text-sm font-semibold uppercase tracking-[0.25em] text-emerald-300">
            Security
          </p>
          <h1 className="text-4xl font-bold md:text-5xl">
            Security you can rely on.
          </h1>
          <p className="mt-5 text-lg leading-8 text-slate-300">
            MekPay is built with practical safeguards across account access, transaction processing, and operational monitoring to protect your funds and data.
          </p>
        </div>

        <div className="mt-12 grid gap-6 md:grid-cols-2">
          {pillars.map((pillar) => {
            const Icon = pillar.icon;
            return (
              <article key={pillar.title} className="rounded-3xl border border-white/10 bg-white/5 p-7 backdrop-blur-sm">
                <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-emerald-400/15 text-emerald-300">
                  <Icon size={24} />
                </div>
                <h2 className="mt-5 text-2xl font-semibold">{pillar.title}</h2>
                <p className="mt-3 text-base leading-7 text-slate-300">{pillar.text}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}